import { render, staticRenderFns } from "./MunicipioNegado.vue?vue&type=template&id=28170fa2"
import script from "./MunicipioNegado.vue?vue&type=script&lang=js"
export * from "./MunicipioNegado.vue?vue&type=script&lang=js"
import style0 from "./MunicipioNegado.vue?vue&type=style&index=0&id=28170fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports